export enum Type {
    Person = 1,
    Company = 2,
}
